import { t } from "@lingui/core/macro";

import { LoyaltyIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

type BalanceCardProps = {
  currentBalance: number;
  pointTerminologyOne: string;
  pointTerminologyOther: string;
};

export const BalanceCard = ({
  currentBalance,
  pointTerminologyOne,
  pointTerminologyOther,
}: BalanceCardProps) => (
  <Box backgroundColor="surface-secondary" borderRadius="2" padding={2}>
    <HStack
      alignItems="center"
      justifyContent="space-between"
      backgroundColor="surface-primary"
      borderRadius="1"
      padding={5}
    >
      <VStack gap={1}>
        <Text variant="mainTiny" color="text-primary">
          {t`Current Balance`}
        </Text>
        <Text variant="mainTitle3" color="text-primary">
          {currentBalance}{" "}
          {currentBalance === 1 ? pointTerminologyOne : pointTerminologyOther}
        </Text>
      </VStack>
      <Box
        width={32}
        height={32}
        borderRadius="4"
        backgroundColor="surface-secondary"
        alignItems="center"
        justifyContent="center"
      >
        <LoyaltyIcon color="icon-primary" width={16} height={16} />
      </Box>
    </HStack>
  </Box>
);
